<script setup lang="ts">
import { useI18n } from "vue-i18n";

import loadingGif from "./loading.gif";

export interface PageLoadingProps {
  onlyLoader?: boolean;
}

const props = withDefaults(defineProps<PageLoadingProps>(), { onlyLoader: false });

const { t } = useI18n();
</script>

<template>
  <div class="loading">
    <img :src="loadingGif" alt="loading animation" class="loading__gif" />

    <p v-if="!props.onlyLoader" class="typography-low-xl color-content-mid text-center">
      {{ t("general.page_loading.title") }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.loading {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__gif {
    @include sp.margin(x, auto);
    @include sp.margin(b, 5);

    height: $size-header-logo-height;
    width: 100px;
    display: block;
  }

  p {
    white-space: pre-line;
  }
}
</style>
